/**
 * Hydrate below-fold homepage sections via Shopify Section Rendering API.
 * Placeholder nodes use [data-sondos-lazy-section="{{ section.id }}"].
 */
(function () {
  var ATTR = 'data-sondos-lazy-section';
  var LOADING = 'data-sondos-lazy-loading';

  function runScripts(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach(function (oldScript) {
      var next = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        next.setAttribute(attr.name, attr.value);
      });
      next.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(next, oldScript);
    });
  }

  function upgradeCustomElements(scope) {
    if (!scope || !window.customElements || !customElements.upgrade) return;
    scope.querySelectorAll('slider-component, product-form, quick-add-modal, media-gallery').forEach(function (el) {
      try {
        customElements.upgrade(el);
      } catch (e) {}
    });
  }

  function hydrate(trigger) {
    var id = trigger.getAttribute(ATTR);
    if (!id || trigger.getAttribute(LOADING) === '1') return;
    trigger.setAttribute(LOADING, '1');

    var path = window.location.pathname || '/';
    var url = path + (path.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('section fetch failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.getElementById('shopify-section-' + id);
        var current = document.getElementById('shopify-section-' + id);
        if (!incoming || !current) throw new Error('section missing');
        current.replaceWith(incoming);
        runScripts(incoming);
        upgradeCustomElements(incoming);
        document.dispatchEvent(
          new CustomEvent('sondos:section:hydrated', { detail: { sectionId: id } })
        );
      })
      .catch(function () {
        trigger.removeAttribute(LOADING);
        trigger.classList.add('sondos-lazy-section--error');
      });
  }

  function init() {
    var nodes = document.querySelectorAll('[' + ATTR + ']');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, hydrate);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          hydrate(entry.target);
        });
      },
      { rootMargin: '180px 0px', threshold: 0.01 }
    );

    Array.prototype.forEach.call(nodes, function (node) {
      io.observe(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
